import { render, staticRenderFns } from "./OverviewLetters.vue?vue&type=template&id=31854b8c"
import script from "./OverviewLetters.vue?vue&type=script&lang=js"
export * from "./OverviewLetters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports